<template>
    <v-app>
        <v-app-bar v-if="isLoggedIn" app color="primary" dark>

            <v-toolbar-title class="ml-5">
                Bisecur Notifications
                <v-chip v-if="mode === 'test'"
                        color="red"
                        dark>
                    Testversion
                </v-chip>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn text @click="logout">
                <v-icon>mdi-logout</v-icon>
                Logout
            </v-btn>

        </v-app-bar>
        <v-main v-if="isLoggedIn " fluid>
            <router-view></router-view>
        </v-main>
        <v-main v-else>
            <LoginView></LoginView>
        </v-main>
        <NotificationSnackbar></NotificationSnackbar>

    </v-app>
</template>

<script>
import config from './config';

import NotificationSnackbar from "./components/NotificationSnackbar";
import LoginView from "./views/LoginView";

import {mapActions, mapGetters} from "vuex";

export default {
    name: "App",
    components: {
        NotificationSnackbar,
        LoginView,
    },
    computed: {
        ...mapGetters('login', [
            'isLoggedIn'
        ]),
        mode() {
            return config.mode;
        },
    },
    methods: {
        ...mapActions('login', [
            'logout'
        ]),
    }
}
</script>

<style scoped>

</style>
